/*
 * Product card image view toggle (product/lifestyle) + swatch hover overlay.
 * Moved out of snippets/product-card.liquid, where it was inlined once per card
 * (16+ copies per collection page, each registering duplicate event listeners).
 * Loaded once, deferred, by every section that renders product cards.
 */
(function () {
  if (window.__kgProductCardViewToggleLoaded) return;
  window.__kgProductCardViewToggleLoaded = true;

document.addEventListener('DOMContentLoaded', () => {
  // --- Knappar (desktop & mobil) ---
  const btnProductDesktop   = document.getElementById('global-show-product-images');
  const btnLifestyleDesktop = document.getElementById('global-show-lifestyle-images');
  const btnProductFab       = document.getElementById('fab-product');
  const btnLifestyleFab     = document.getElementById('fab-lifestyle');

  /* ---------- Overlay helpers (för att undvika delay) ---------- */
  function removeOverlayForThumb(thumb){
    const overlay = thumb?._overlayImg;
    if (!overlay) return;
    overlay.style.transition = 'none'; // ta bort direkt, ingen fade
    overlay.remove();
    thumb._overlayImg = null;
  }

  function cleanupHoverInCard(card){
    // Ta bort alla overlays i kortet
    card.querySelectorAll('.hover-fade-img').forEach(el => {
      el.style.transition = 'none';
      el.remove();
    });
    // Nollställ referenser på alla thumbnails i kortet
    card.querySelectorAll('.color-thumbnail').forEach(thumb => {
      if (thumb._overlayImg) {
        thumb._overlayImg.style.transition = 'none';
        thumb._overlayImg.remove();
        thumb._overlayImg = null;
      }
    });
  }

  function createOverlayFromThumb(thumb){
    const card      = thumb.closest('product-card') || thumb.closest('.card');
    const container = card?.querySelector('.media');
    const active    = card?.querySelector('img.card__main-image-2.is-active');
    const hoverSrc  = thumb?.dataset.hoverImage;
    if (!container || !active || !hoverSrc) return;

    const overlay = active.cloneNode();
    overlay.removeAttribute('srcset');     // undvik layoutskift
    overlay.classList.remove('is-active');
    overlay.classList.add('hover-fade-img');
    overlay.src = hoverSrc;

    container.appendChild(overlay);
    requestAnimationFrame(() => overlay.classList.add('visible')); // starta fade
    thumb._overlayImg = overlay;
  }

  function reapplyHoverIfNeeded(card){
    // Om användaren fortfarande hovrar en swatch efter vybyte – lägg overlay igen direkt
    const hoveredThumbs = card.querySelectorAll('.color-thumbnail:hover');
    hoveredThumbs.forEach(thumb => {
      removeOverlayForThumb(thumb);
      createOverlayFromThumb(thumb);
    });
  }

  /* ---------- UI-sync ---------- */
  function syncToggleUI(type){
    const isProduct   = type === 'product';
    const isLifestyle = type === 'lifestyle';

    // Desktop
    btnProductDesktop?.classList.toggle('active', isProduct);
    btnLifestyleDesktop?.classList.toggle('active', isLifestyle);
    btnProductDesktop?.setAttribute('aria-pressed', isProduct ? 'true' : 'false');
    btnLifestyleDesktop?.setAttribute('aria-pressed', isLifestyle ? 'true' : 'false');

    // Mobil (FAB)
    btnProductFab?.classList.toggle('active', isProduct);
    btnLifestyleFab?.classList.toggle('active', isLifestyle);
    btnProductFab?.setAttribute('aria-pressed', isProduct ? 'true' : 'false');
    btnLifestyleFab?.setAttribute('aria-pressed', isLifestyle ? 'true' : 'false');
  }

  // Uppdatera vilken hover-bild som ska användas i color-thumbnails (per kort)
  function updateHoverImages(typeToShow, scope = document){
    scope.querySelectorAll('.color-thumbnail').forEach(thumb => {
      const productHover   = thumb.dataset.hoverImageProduct;
      const lifestyleHover = thumb.dataset.hoverImageLifestyle;
      const chosen = typeToShow === 'product' ? productHover : lifestyleHover;
      if (chosen) thumb.setAttribute('data-hover-image', chosen);
    });
  }

  /* ---------- Växla vy på ett kort ---------- */
  function applyViewToCard(card, typeToShow){
    // 0) Städa bort ev. overlay först så inget ligger kvar och orsakar delay
    cleanupHoverInCard(card);

    // 1) Växla huvudbild via .is-active
    const mains = card.querySelectorAll('img.card__main-image-2');
    mains.forEach(img => img.classList.remove('is-active'));
    const target = [...mains].find(img => img.dataset.imageType === typeToShow) || mains[0];
    if (target) target.classList.add('is-active');

    // 2) Swatches togglar .visible som vanligt
    const swatches = card.querySelectorAll('img.swatch-image');
    swatches.forEach(img => {
      img.classList.toggle('visible', img.dataset.imageType === typeToShow);
    });

    // 3) Uppdatera vilken hover-bild som ska användas (product/lifestyle)
    updateHoverImages(typeToShow, card);

    // 4) Om en swatch fortfarande är hovered – lägg overlay igen direkt
    reapplyHoverIfNeeded(card);
  }

  /* ---------- Växla alla kort ---------- */
  function applyView(typeToShow){
    document.querySelectorAll('product-card[data-initial-view]').forEach(card => {
      applyViewToCard(card, typeToShow);
    });
    syncToggleUI(typeToShow);
  }

  // Gör funktionen globalt tillgänglig
  window.applyImageView = applyView;

  // --- Init: bestäm startvy ---
  const firstCard   = document.querySelector('product-card[data-initial-view]');
  let currentViewType =
    firstCard?.dataset.initialView ||
    (btnProductDesktop?.classList.contains('active') ? 'product' : 'lifestyle') ||
    'lifestyle';

  applyView(currentViewType);

  // --- Events: desktop + mobil använder samma applyView ---
  btnProductDesktop?.addEventListener('click', () => { currentViewType = 'product'; applyView('product'); });
  btnLifestyleDesktop?.addEventListener('click', () => { currentViewType = 'lifestyle'; applyView('lifestyle'); });
  btnProductFab?.addEventListener('click', () => { currentViewType = 'product'; applyView('product'); });
  btnLifestyleFab?.addEventListener('click', () => { currentViewType = 'lifestyle'; applyView('lifestyle'); });

  // --- Swatch-hover med overlay (ingen src-swap på aktiva bilden) ---
  function bindColorThumbnailHover(scope){
    scope.querySelectorAll('.color-thumbnail').forEach(thumb => {
      if (thumb._kgHoverBound) return;
      thumb._kgHoverBound = true;
      thumb.addEventListener('mouseenter', () => {
        // Säkerställ att ingen gammal overlay ligger kvar
        removeOverlayForThumb(thumb);
        createOverlayFromThumb(thumb);
      });

      thumb.addEventListener('mouseleave', () => {
        removeOverlayForThumb(thumb);
      });
    });
  }

  bindColorThumbnailHover(document);

  // --- Public API for cards injected after DOMContentLoaded (e.g. the favourites page,
  // which fetches product-card markup via the Section Rendering API): applies the current
  // product/lifestyle view and binds swatch-hover for every card within the given scope. ---
  window.KGProductCardViewToggle = {
    initCards: function (scope) {
      scope = scope || document;
      scope.querySelectorAll('product-card[data-initial-view]').forEach(card => {
        applyViewToCard(card, currentViewType);
      });
      bindColorThumbnailHover(scope);
    }
  };
});
})();
